var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('es-clip',{on:{"clipImg":_vm.clipImage}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }